import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import LinearProgress from "@mui/material/LinearProgress";
import { DialogActions, DialogContent, Grid } from "@mui/material";
import ExcelIcon from "./../../Assests/excel.svg";
import CancelIconRed from "./../../Assests/cancel.svg";
import * as actions from "./../../Redux/Actions/index";

function UploadingMasterFile(props: any) {
  const dispatch = useDispatch();
  const [progress, setProgress] = React.useState(0);

  const { isLoading, isLoadingBaseLine } = useSelector(
    (state: any) => state.InputDataReducers
  );

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        // if (oldProgress === 100) {
        //   if (isUploadBaseLineData) {
        //     props.handleOpenBaseLineUploader(true);
        //   } else {
        //     props.handleOpenDoneDialog(true);
        //   }
        //   return 0;
        // }
        if (!isLoading) {
          return 0;
        }
        // else if (isBaseLineUploader) {
        //   setTimeout(() => {
        //     return 0;
        //   }, 2000);
        // }
        const diff = Math.random() * 2;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, [isLoading]);

  useEffect(() => {
    var timer: any;
    if (isLoadingBaseLine) {
      timer = setTimeout(() => {
        dispatch(actions.baseLineUploader());
      }, 2000);
    }
    return () => {
      clearInterval(timer);
    };
  }, [isLoadingBaseLine]);

  console.log(props.getData, "props.getData in uploading master file");
  return (
    <>
      <DialogContent className="modal-body">
        {props.getData &&
          props.getData.map((ele: any, i: any) => {
            return (
              <div key={i}>
                <div className="progressbar-area">
                  <Grid container spacing={1} className="uploadFile">
                    <Grid item xs={6} md={6} lg={6}>
                      <span>
                        {i + 1}
                        {". "}
                      </span>
                      <span> {ele.name}</span>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <div className="seletcedFilename">
                        {ele.selectedFile?.name !== undefined ? (
                          <>
                            <img src={ExcelIcon} alt="" />{" "}
                            <span>
                              {" "}
                              {ele.selectedFile?.name}
                              {/* {`(${ele.selectedFile?.size})`} */}
                            </span>{" "}
                            <span
                              className="cancel-file"
                              onClick={(e) => props.handleCancelFile(e, ele)}
                            >
                              <img src={CancelIconRed} alt="" />
                            </span>
                          </>
                        ) : (
                          <span>Not Selected</span>
                        )}
                      </div>
                    </Grid>
                  </Grid>
                  <Box sx={{ width: "100%" }}>
                    {ele.selectedFile?.name !== undefined ? (
                      <LinearProgress variant="determinate" value={progress} />
                    ) : null}
                  </Box>
                </div>
              </div>
            );
          })}
      </DialogContent>
      <DialogActions>
        <div className="modal-action"></div>
      </DialogActions>
    </>
  );
}

export default UploadingMasterFile;
